/**
 * Component: Read More
 * ------------------------------------------------------------------------------
 * Expand a text section
 *
 * @namespace readMore
 */
import log from 'salvo-lite/log'
import cssClasses from '../helpers/cssClasses'

class aReadMore {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            maxCount: 150,
            moreLinkText: 'Read more',
            lessLinkText: 'Read less',
            ...JSON.parse(elem.getAttribute('data-readmore') || '{}')
        }

        this._selectors = {
            toggle: '[data-readmore-toggle]'
        }

        this._originalContent = this._elem.innerHTML
        this._originalContentArray = this._originalContent.split(' ')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        this._setLanguage()
        this._countWords()
    }

    _countWords () {
        if (this._originalContentArray.length > this._settings.maxCount) {
            const maxContent = this._originalContentArray.slice(0, this._settings.maxCount).join(' ')
            this._elem.innerHTML = maxContent + '...'
            this._elem.classList.add(cssClasses.active)

            this._insertToggleLink()
        }
    }

    _addEventListeners () {
        this._elem.querySelector(this._selectors.toggle).addEventListener('click', () => this._handleToggle())
    }

    _handleToggle () {
        if (this._elem.classList.contains(cssClasses.active)) {
            this._elem.innerHTML = this._originalContent
            this._elem.classList.remove(cssClasses.active)
        } else {
            const maxContent = this._originalContentArray.slice(0, this._settings.maxCount).join(' ')
            this._elem.innerHTML = maxContent + '...'
            this._elem.classList.add(cssClasses.active)
        }

        this._insertToggleLink()
    }

    _insertToggleLink () {
        if (this._elem.classList.contains(cssClasses.active)) {
            this._elem.insertAdjacentHTML('beforeend', `<button class="product-tabs__readmore" data-readmore-toggle>${this._settings.moreLinkText}</button>`)
        } else {
            this._elem.insertAdjacentHTML('beforeend', `<button class="product-tabs__readmore" data-readmore-toggle>${this._settings.lessLinkText}</button>`)
        }

        this._addEventListeners()
    }

    _setLanguage () {
        if (window.theme.store.id === 'de_store') {
            this._settings.moreLinkText = 'Weiterlesen'
            this._settings.lessLinkText = 'Lese weniger'
        }
    }
}

export default aReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js